const SKATERS = 'skater';
const GOALIES = 'goalie';
const TEAMS = 'team';
const GAMES = 'game';
const SKATER_CAREER = 'skater-career';
const GOALIE_CAREER = 'goalie-career';
const LEAGUE = 'league';
const HEAD_COACH = 'head-coach';
const FRANCHISE = 'franchise';
const MISCELLANEOUS = 'miscellaneous';

export default {
    SKATERS,
    GOALIES,
    TEAMS,
    GAMES,
    SKATER_CAREER,
    GOALIE_CAREER,
    LEAGUE,
    HEAD_COACH,
    FRANCHISE,
    MISCELLANEOUS,
};